import { BrandContext } from '../contexts/brand'
import { useContext, useMemo } from 'react'
import { Brand, DEFAULT_BRAND } from '../types/brand'

export function useBrand (): Brand {
  const { brand } = useContext(BrandContext)
  return brand
}

export function useBrandBasePath (): '' | `/${string}` {
  const brand = useBrand()
  return useMemo(() => brand === DEFAULT_BRAND ? '' : `/${brand}` as const, [brand])
}
